import { Component, Prop, h } from '@stencil/core';
import Icon from '../svg/hospital.svg'

@Component({
  tag: 'cr-icon-facility',
  styleUrl: '../cr-icon.css',
  shadow: true,
})
export class CrIconFacility {
  /**
   * The size of the icon - can be 'small', 'medium' or 'large'
   */
  @Prop() size: string

  render() {

    return (
      <div
        class={this.size}
        innerHTML={Icon}
      />
    );
  }

}
